import React from "react";

const Skills = () => {
  return (
    <>
      <div className="CIGI_tm_section">
        <div className="CIGI_tm_skills">
          <div className="container">
            <div className="skills_inner">
              <div className="left">
                <div className="cigi_title">
                  <h3>~Highlighted Skills~ </h3>
                </div>
                <div className="text">
                  <p>
                    Recently graduated an intense 6 month Full Mern Stack 
                    immersive bootcamp to further enhance my skillset with Visual Asset management
                    and creation to strengthen clients online presence. Using React, Java Script, CSS, SCSS and 
                    utilizing tools including: VS Code, Figma, Photoshop, GitHub and Trello. 
                  </p>
                </div>
              </div>
              {/* End .left */}

              <div className="right">
                <div className="tokyo_progress">
                  <div className="progress_inner">
                    <span>
                      <span className="label">Web Development</span>
                    </span>
                    </div>
                  </div>
                  {/* End .progress_inner */}
                  <div className="tokyo_progress">
                  <div className="progress_inner">
                    <span>
                      <span className="label">Brand Identity</span>
                    </span>
                    </div>
                  </div>
                  {/* End .progress_inner */}
                  <div className="tokyo_progress">
                  <div className="progress_inner">
                    <span>
                      <span className="label">UX Design</span>
                    </span>
                    </div>
                  </div>
                  {/* End .progress_inner */}
                  <div className="tokyo_progress">
                  <div className="progress_inner">
                    <span>
                      <span className="label">Visual Asset Creation/Management </span>
                    </span>
                    </div>
                  </div>
                  {/* End .progress_inner */}
                  <div className="tokyo_progress">
                  <div className="progress_inner">
                    <span>
                      <span className="label">Photography and Videography </span>
                    </span>
                    </div>
                  </div>
                  {/* End .progress_inner */}
                  <div className="tokyo_progress">
                  <div className="progress_inner">
                    <span>
                      <span className="label">Art Direction</span>
                    </span>
                    </div>
                  </div>
                  {/* End .progress_inner */}
                </div>
              </div>
              {/* End .right */}
            </div>
          </div>
          {/* End .container */}
        </div>
    </>
  );
};

export default Skills;
